<template>
    <div>
        <h3 class="form-section-title d-flex align-items-center">{{title}}

            <b-button size="sm" variant="link" @click.stop.prevent="onAddClick" v-if="dialogRef" class="icon-button">
                <font-awesome-icon icon="plus-circle"/>
            </b-button>
        </h3>
    </div>
</template>

<script>
    export default {
        name: "FormSectionHeader",

        props: {
            title: {
                type: String,
                required: true
            },

            dialogRef: {
                type: Object
            }
        },

        methods: {
            onAddClick() {

                this.dialogRef.openDialog();
            }
        }
    }
</script>

<style scoped lang="scss">

    .icon-button {
        margin: 0 0 0 6px;
        padding: 0;
        line-height: 1;

        svg {
            margin: 0;
            padding: 0;
            font-size: 1rem;
        }
    }
</style>